"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const StyledFunctions_1 = require("../helpers/StyledFunctions");
const Flex_1 = tslib_1.__importDefault(require("./Elements/Flex"));
const Alert = (0, styled_components_1.default)(Flex_1.default) `
  ${StyledFunctions_1.elementType};
  ${StyledFunctions_1.elementSize};
  ${StyledFunctions_1.getMargin};
  ${StyledFunctions_1.getPadding};
`;
exports.default = Alert;
